<ion-toolbar *ngIf="selectedSet" style="max-width: 768px; margin: auto">
    @let segementLable = match.discipline === 'PICKLEBALL' ? 'Game' : 'Set';
    <ion-segment (ionChange)="selectSet($event)" [value]="match.sets.length">
        <ion-segment-button [value]="1">
            <ion-label>{{ segementLable }} 1</ion-label>
        </ion-segment-button>
        <ion-segment-button [value]="2" *ngIf="match.sets.length > 1">
            <ion-label>{{ segementLable }} 2</ion-label>
        </ion-segment-button>
        <ion-segment-button [value]="3" *ngIf="match.sets.length > 2">
            <ion-label>{{ segementLable }} 3</ion-label>
        </ion-segment-button>
        <ion-segment-button [value]="4" *ngIf="match.sets.length > 3">
            <ion-label>{{ segementLable }} 4</ion-label>
        </ion-segment-button>
        <ion-segment-button [value]="5" *ngIf="match.sets.length > 4">
            <ion-label>{{ segementLable }} 5</ion-label>
        </ion-segment-button>
    </ion-segment>
</ion-toolbar>

@if (match) {
    <ion-grid class="ion-no-padding" [ngClass]="{'content-width': !isOfficial}">

        @if (selectedSet) {

            @if (match.discipline !== 'PICKLEBALL') {
                <ion-row class="score-list-row" [style.background]="rowStyle">
                    <ion-col class="ion-text-left" style="color: white">
                        {{ !isReverse ? participantSide1 : participantSide2 }}
                    </ion-col>

                    <ion-col class="ion-text-right" style="color: white">
                        {{ isReverse ? participantSide1 : participantSide2 }}
                    </ion-col>
                </ion-row>
            }

            @for (game of match.sets[selectedSet - 1].games.slice().reverse(); track $index) {
                @for (pt of game.points.slice().reverse(); let isGameRow = $first; let j = $index; track j;) {
                    @if (isOfficial || match.discipline === 'PICKLEBALL') {
                        <app-point-row
                            [point]="pt"
                            [game]="game"
                            [sets]="match.sets"
                            [sides]="match.sides"
                            [isGameRow]="isGameRow"
                            [timeItems]="match.timeItems"
                            [selectedSet]="selectedSet"
                            [discipline]="match.discipline"
                            [scoreFormat]="scoreFormat"
                            [matchType]="match.matchType">
                        </app-point-row>
                        <div style="height: 10px;"></div>
                    } @else {
                        <ion-row class="ion-no-padding">

                            <ion-col size="12">
                                <div class="score-row" [ngClass]="{ 'game-row': isGameRow}">

                                    <!-- Side 1 serve/return -->
                                    <div class="col-serve serve-left">
                                        <div *ngIf="pt.server?.sideNumber===1 && (!isGameRow || (isGameRow && !(game.side1Score===0 && game.side2Score===0 )))">
                                            <ion-text [ngClass]="{ 'success-color': pt.winningSide && pt.winReason, 'warning-color': (pt.shots.length && pt.shots[0].shotType==='SE' && (pt.shots[0].shotOutcome==='O' || pt.shots[0].shotOutcome==='FOOT_FAULT' )),
                            'danger-color': pt.winReason==='DF' }">
                                                S<sup style="text-transform: lowercase">{{ getServeLocation(pt) }}</sup>
                                            </ion-text>
                                        </div>
                                        <div *ngIf="pt.shots.length && pt.server?.sideNumber===2 && pt.winningSide && pt.winReason">
                                            <ion-text *ngIf="pt.winReason !=='DF'" [ngClass]="{ 'success-color': returnMade(pt)==='made' , 'danger-color': returnMade(pt)==='missed' }">
                                                R
                                            </ion-text>
                                        </div>
                                    </div>
                                    <div class="col-stats ion-text-left">
                                        {{ pt.winningSide === 1 ? winReason[pt.winReason] :""}}
                                    </div>
                                    <div class="col-score">
                                        <!-- Point row -->
                                        <div [hidden]="j===0">
                                            {{ getScore(game.gameFormat, pt.side1Score) }} - {{ getScore(game.gameFormat, pt.side2Score) }}
                                        </div>

                                        <!-- Game row -->
                                        <div [hidden]="j !==0">
                                            <span [hidden]="game.side1Score===0 && game.side2Score===0">
                                                {{ game.side1Score }} - {{ game.side2Score }}
                                            </span>
                                            <span [hidden]="!(game.side1Score===0 && game.side2Score===0 )">
                                                Game {{ match.sets[selectedSet - 1].games.length }}
                                            </span>
                                        </div>
                                    </div>
                                    <div class="col-stats ion-text-right">
                                        {{ pt.winningSide === 2 ? winReason[pt.winReason] :""}}
                                    </div>

                                    <!-- Side 2 serve/return -->
                                    <div class="col-serve serve-right">
                                        <div *ngIf="pt.server?.sideNumber===2 && (j !==0 || (j===0 && !(game.side1Score===0 && game.side2Score===0 )))">
                                            <ion-text [ngClass]="{ 'success-color': pt.winningSide && pt.winReason, 'warning-color': (pt.shots.length && pt.shots[0].shotType==='SE' && (pt.shots[0].shotOutcome==='O' || pt.shots[0].shotOutcome==='FOOT_FAULT' )),
                            'danger-color': pt.winReason==='DF' }">
                                                S<sup style="text-transform: lowercase">{{ getServeLocation(pt) }}</sup>
                                            </ion-text>
                                        </div>
                                        <div *ngIf="pt.shots.length && pt.server?.sideNumber===1 && pt.winningSide && pt.winReason">
                                            <ion-text *ngIf="pt.winReason !=='DF'" [ngClass]="{ 'success-color': returnMade(pt)==='made' , 'danger-color': returnMade(pt)==='missed' }">
                                                R
                                            </ion-text>
                                        </div>
                                    </div>
                                </div>
                            </ion-col>

                        </ion-row>
                    }
                }
            }
        }

    </ion-grid>
}